import React, { Component } from 'react';
import * as regex from '../../../constants/regex';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import { politeDropDownDefault } from '../../constants/webAppointmentConstants'
import * as defaultState from '../../constants/DefaultState';
import * as formatData from '../../functions/formatData';
import apiGet from '../../../shared/functions/apiGet';

export class NewPatientAddressPhonePage extends Component {
  emptyChoice = politeDropDownDefault;
  states = [{ name: politeDropDownDefault, value: undefined }];
  constructor(props) {
    super(props);
    this.state = {
      rerender: 1
    };
  }

  getStates = () => {
    let options = { params: { country: "USA" } };
    return new Promise((resolve, reject) => {
      apiGet("/api/sitecore/webappointment/getStatesOrProvinces", options, null, null, null, false, false, false)
        .then((states) => {
          resolve(states);
        })
        .catch((error) => {
          console.log("get states call failed, falling back to hardcoded abbreviations.");
          console.log(error);
          let options = [
            { name: politeDropDownDefault, value: undefined },
            { name: "AL", value: "Alabama" },
            { name: "AK", value: "Alaska" },
            { name: "AZ", value: "Arizona" },
            { name: "AR", value: "Arkansas" },
            { name: "CA", value: "California" },
            { name: "CO", value: "Colorado" },
            { name: "CT", value: "Connecticut" },
            { name: "DE", value: "Delaware" },
            { name: "DC", value: "District of Columbia" },
            { name: "FL", value: "Florida" },
            { name: "GA", value: "Georgia" },
            { name: "HI", value: "Hawaii" },
            { name: "ID", value: "Idaho" },
            { name: "IL", value: "Illinois" },
            { name: "IN", value: "Indiana" },
            { name: "IA", value: "Iowa" },
            { name: "KS", value: "Kansas" },
            { name: "KY", value: "Kentucky" },
            { name: "LA", value: "Louisiana" },
            { name: "ME", value: "Maine" },
            { name: "MD", value: "Maryland" },
            { name: "MA", value: "Massachusetts" },
            { name: "MI", value: "Michigan" },
            { name: "MN", value: "Minnesota" },
            { name: "MS", value: "Mississippi" },
            { name: "MO", value: "Missouri" },
            { name: "MT", value: "Montana" },
            { name: "NE", value: "Nebraska" },
            { name: "NV", value: "Nevada" },
            { name: "NH", value: "New Hampshire" },
            { name: "NJ", value: "New Jersey" },
            { name: "NM", value: "New Mexico" },
            { name: "NY", value: "New York" },
            { name: "NC", value: "North Carolina" },
            { name: "ND", value: "North Dakota" },
            { name: "OH", value: "Ohio" },
            { name: "OK", value: "Oklahoma" },
            { name: "OR", value: "Oregon" },
            { name: "PA", value: "Pennsylvania" },
            { name: "PR", value: "Puerto Rico" },
            { name: "RI", value: "Rhode Island" },
            { name: "SC", value: "South Carolina" },
            { name: "SD", value: "South Dakota" },
            { name: "TN", value: "Tennessee" },
            { name: "TX", value: "Texas" },
            { name: "UT", value: "Utah" },
            { name: "VT", value: "Vermont" },
            { name: "VI", value: "Virgin Islands" },
            { name: "VA", value: "Virginia" },
            { name: "WA", value: "Washington" },
            { name: "WV", value: "West Virginia" },
            { name: "WI", value: "Wisconsin" },
            { name: "WY", value: "Wyoming" }
          ];
          this.states = options;
          // Tweak the state just enough to call render() again.
          this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
        });
    });
  }

  fillStates() {
    this.getStates()
      .then((states) => {
        // process 'locations' - i.e. save locally so that render() can get to them.
        this.states = states.map(s => {
          return { value: s.Value, name: s.Value };
        })
        this.states.unshift({ name: politeDropDownDefault, value: undefined });
        // Tweak the state just enough to call render() again.
        this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
      });
  }

  // Lifecycle Method:
  componentDidMount() {
    this.fillStates();
  }

  isValid() {
    let valid = (
      this.props.patient.address1 &&
      this.props.patient.city &&
      this.props.patient.state &&
      this.props.patient.zip && this.props.patient.zip.match(regex.ZIP_CODE_REGEX) &&
      ( this.props.patient.phone === "" || this.props.patient.phone.match(regex.NUMERIC_PHONE_NUMBER_REGEX) )
    );
    if (this.props.forMe) {
      valid = (
        valid &&
        this.props.patient.email &&
        this.props.patient.email.match(regex.EMAIL_REGEX) &&
        this.props.patient.phone &&
        this.props.patient.phone.match(regex.NUMERIC_PHONE_NUMBER_REGEX)
      );
    }
    return !!valid;
  }

  render() {
    let title = this.props.forMe ?
      "How can we contact you about your appointment?" :
      "Please provide the patient’s address and contact information.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'text',
            id: 'address1',
            required: true,
            requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " street address.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            label: this.props.forMe ? "Address" : "Patient’s address",
            helperText: "House number and street name",
            onChange: (ev) => { this.props.webAppointmentSetPatientAddress1(ev.target.value); },
            existingContent: this.props.patient.address1 || undefined,
            maxLength: '46'
          },
          {
            type: 'text',
            id: 'address2',
            label: this.props.forMe ? "Address continued (Optional)" : "Patient’s address continued (Optional)",
            helperText: "Apartment number if applicable",
            onChange: (ev) => { this.props.webAppointmentSetPatientAddress2(ev.target.value); },
            existingContent: this.props.patient.address2 || undefined,
            maxLength: '46'
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 3,
        inputs: [
          [
            {
              type: 'text',
              id: 'city',
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " city.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              label: this.props.forMe ? "City" : "Patient’s city",
              onChange: (ev) => { 
                const formattedCity = formatData.formatCityString(ev.target.value);
                this.props.webAppointmentSetPatientCity(formattedCity); 
              },
              existingContent: this.props.patient.city || undefined,
              maxLength: '140'
            }
          ],
          [
            {
              type: 'select',
              id: 'state',
              key: 'state',
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " state.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              label: this.props.forMe ? "State" : "Patient’s state",
              onChange: (value) => { this.props.webAppointmentSetPatientState(value === politeDropDownDefault ? "" : value); },
              existingContent: this.props.patient.state ? this.props.patient.state.split("|")[0] : undefined,
              options: this.states
            }
          ],
          [
            {
              type: 'text',
              id: 'zip',
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " zip code.",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              patternMatch: regex.ZIP_CODE_REGEX,
              patternMatchError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " zip code.",
              label: this.props.forMe ? "Zip code" : "Patient’s zip code",
              onChange: (ev) => {
                const formattedZip = formatData.formatZipString(ev.target.value, ev.target.selectionStart);
                this.props.webAppointmentSetPatientZip(formattedZip);
              },
              existingContent: this.props.patient.zip,
              maxLength: '10'
            }
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
              // "This is for me" conditional inputs.
              this.props.forMe ? {
                id: 'email',
                type: 'text',
                label: "Email",
                required: true,
                requiredError: "Please enter your email address in this format: yourname@example.com",
                validateOnBlur: true,
                validateOnChange: true,
                validationErrorClass: "web-appointment__error",
                patternMatch: regex.EMAIL_REGEX,
                patternMatchError: "Please enter your email address in this format: yourname@example.com",
                existingContent: this.props.patient.email,
                onChange: (ev) => { 
                  const formattedEmail = ev.target.value.replace(/\s/g, '');
                  this.props.webAppointmentSetPatientEmail(formattedEmail);
                  return formattedEmail;
                }
              } : {},
              // end of "This is for me" conditional inputs.
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              id: "Phone number",
              type: 'text',
              key: "new-patient-phone",
              label: (this.props.forMe ? "Phone number" : "Patient’s phone number (Optional)"),
              required: this.props.forMe,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s" ) + " phone number with the area code.",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              patternMatch: regex.NUMERIC_PHONE_NUMBER_REGEX,
              patternMatchError: "Please enter " + (this.props.forMe ? "your" : "the patient’s" ) + " phone number with the area code.",
              existingContent: this.props.patient.phone,
              onChange: (ev) => {
                let newValues = formatData.formatPhone(ev.target.value, ev.target.selectionStart);
                this.props.webAppointmentSetPatientPhone(newValues.value);
                return newValues;
              }
            }
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: 'Next',
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

NewPatientAddressPhonePage.propTypes = {
  patient: defaultState.patientPropType,
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetPatientAddress1: PropTypes.func.isRequired,
  webAppointmentSetPatientAddress2: PropTypes.func.isRequired,
  webAppointmentSetPatientCity: PropTypes.func.isRequired,
  webAppointmentSetPatientState: PropTypes.func.isRequired,
  webAppointmentSetPatientZip: PropTypes.func.isRequired,
  webAppointmentSetPatientEmail: PropTypes.func.isRequired,
  webAppointmentSetPatientPhone: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    forMe: state.webAppointmentForm.forMe,
    patient: state.webAppointmentForm.patient
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetPatientAddress1: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientAddress1(value)),
    webAppointmentSetPatientAddress2: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientAddress2(value)),
    webAppointmentSetPatientCity: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientCity(value)),
    webAppointmentSetPatientState: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientState(value)),
    webAppointmentSetPatientZip: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientZip(value)),
    webAppointmentSetPatientEmail: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientEmail(value)),
    webAppointmentSetPatientPhone: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientPhone(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(NewPatientAddressPhonePage);
